module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('ui-title-red', {
    attrs: {
      "textTitle": "Efectividad"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "adorn-top-right",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": "",
      "pt-5": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('ui-simple-lsc', {
    attrs: {
      "vidTittle": 'Efectividad',
      "videoEmbed": "ADMINISTRACIONDINERO12Efectividad (ant43).mp4"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInLeft adorn-bottom-left",
    attrs: {
      "xs12": "",
      "sm4": "",
      "text-xs-center": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 400,
      "imaSrc": "contenido/diapositiva_12",
      "imaAlt": "Cuatro engranajes funcionando"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInLeft dura_1",
    attrs: {
      "xs12": "",
      "sm2": "",
      "text-xs-center": "",
      "hidden-xs-only": ""
    }
  }, [_c('image-app', {
    attrs: {
      "imaSize": 120,
      "imaSrc": "design/red-arrow",
      "imaAlt": ""
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "animated fadeInUp dura_1 ",
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('p', [_vm._v("\n        Para\n        "), _c('strong', [_vm._v("mejorar")]), _vm._v(" nuestra\n        "), _c('strong', [_vm._v("efectividad")]), _vm._v(" en la administración del dinero, vamos a conocer algunos conceptos clave como:\n        "), _c('strong', [_vm._v("ingresos, gastos, presupuesto y patrimonio.")]), _c('br'), _c('br'), _vm._v(" También vamos a obtener algunas herramientas muy útiles y sencillas que nos van a ayudar a seguir consolidando nuestro\n        "), _c('strong', [_vm._v("futuro financiero")]), _vm._v(".\n      ")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5581a03c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda-12.vue
// module id = 982
// module chunks = 1